// frontend/src/pages/QuestionnaireSuccess.js
import React from 'react';
import { Link } from 'react-router-dom';

const QuestionnaireSuccess = () => {
  return (
    <div className="container py-5">
      <div className="card shadow-sm">
        <div className="card-body text-center py-5">
          <div className="mb-4">
            <i className="fas fa-check-circle text-success" style={{ fontSize: '5rem' }}></i>
          </div>
          
          <h2 className="mb-3">บันทึกแบบสอบถามเรียบร้อยแล้ว</h2>
          <p className="lead mb-4">
            ขอบคุณที่สละเวลาในการตอบแบบสอบถาม
            <br />
            ความคิดเห็นของท่านจะเป็นประโยชน์ในการพัฒนาคุณภาพการศึกษาต่อไป
          </p>
          
          <Link to="/" className="btn btn-primary">
            <i className="fas fa-home me-2"></i>
            กลับหน้าหลัก
          </Link>
        </div>
        
        <div className="card-footer text-center text-muted">
          <small>ระบบประเมินคุณธรรมและความโปร่งใสในการดำเนินงานของหน่วยงานภาครัฐ</small>
          <div className="mt-1">
            <small>สำนักงานเขตพื้นที่การศึกษาประถมศึกษาศรีสะเกษ เขต 3</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireSuccess;